import { range } from "ramda";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { useScreen } from "hooks";
import Placeholder from "components/Placeholder";

import Slider from "../Slider";
import StyledSwiperSlide from "../Styled/StyledSwiperSlide";

const CategoryFeatureSkeleton = () => {
  const { isMobile } = useScreen();

  return (
    <div data-testid="skeleton-component">
      <Slider>
        {range(0, 5).map((index) => (
          <StyledSwiperSlide key={`carousel-skeleton-${index}`}>
            <Placeholder variant="rect" height={isMobile ? 199 : 430} animation="pulse" style={{ borderRadius: 8 }} />
          </StyledSwiperSlide>
        ))}
      </Slider>
    </div>
  );
};

export default CategoryFeatureSkeleton;
